import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import ActionCard, { ActionCardProps } from '../action-card/ActionCard';
import ContactAvatar from '../action-card/ContactAvatar';
import ExploreAvatar from '../action-card/ExploreAvatar';
import FaqAvatar from '../action-card/FaqAvatar';
import JoinSimulationCard from '../action-card/JoinSimulationCard';
import AppBar from '../app-bar/AppBar';

interface Option extends ActionCardProps {
  key: number;
}

const options: Option[] = [
  {
    actionText: 'Explore',
    avatar: <ExploreAvatar />,
    key: 1,
    to: '',
    text: 'We redefine maritime simulation for training and education. Explore our service offering of simulators.',
    title: 'Explore',
  },
  {
    actionText: 'FAQ',
    avatar: <FaqAvatar />,
    key: 2,
    to: '../help-center/faq',
    text: 'Read our frequently asked questions to find the information that most users wonder about.',
    title: 'FAQ',
  },
  {
    actionText: 'Contact support',
    avatar: <ContactAvatar />,
    key: 3,
    to: '../help-center/contact-us',
    text: "Can't find the answers you are looking for? Get in touch with our team directly during weekdays. We try our best to respond quickly.",
    title: 'Contact support',
  },
];

const handleClick = (text: string) => {
  if (text.toLowerCase() === 'explore') {
    window.location.href = '/v2/i/marketplace';
  }
};

const Home = () => (
  <>
    <AppBar title="Home" />
    <Container sx={{ my: 4 }}>
      <Typography component="h1" variant="h3" pt={7} mb={1}>
        Welcome to the K-Sim Connect community
      </Typography>
      <Typography component="p" variant="subtitle1" color="text.secondary" mb={6} fontWeight="bold">
        We are excited to welcome you to our global community of maritime simulation based training solutions. Select
        one of these options to get started.
      </Typography>

      <Box display="flex" gap={3} flexDirection={{ xs: 'column', sm: 'row' }} mb={3}>
        <JoinSimulationCard />
        {options.map(option => (
          <ActionCard {...option} key={option.key} handleClick={() => handleClick(option.actionText)} />
        ))}
      </Box>
    </Container>
  </>
);

export default Home;
